import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';

interface CacheContent {
  expiry: number;
  value: any;
}

@Injectable()
export class CacheService {
  public readonly DEFAULT_MAX_AGE: number = 300;
  private cache: Map<string, CacheContent> = new Map<string, CacheContent>();

  constructor() {}

  public get<T>(key: string, fallback?: Observable<T>, maxAge: number = this.DEFAULT_MAX_AGE): Observable<T> {
    if (this.hasValidCachedValue(key)) {
      return of(this.cache.get(key).value) as Observable<T>;
    }

    return fallback.pipe(
      tap((value) => {
        this.set(key, value, maxAge);
      }),
    );
  }

  public hasValidCachedValue(key: string): boolean {
    if (this.cache.has(key)) {
      if (this.cache.get(key).expiry < Date.now()) {
        this.cache.delete(key);

        return false;
      }

      return true;
    }

    return false;
  }

  private set(key: string, value: any, maxAge: number = this.DEFAULT_MAX_AGE) {
    this.cache.set(key, { value: value, expiry: Date.now().valueOf() + this.DEFAULT_MAX_AGE * 1000 });
  }
}
